import { StringParam, useQueryParam } from "use-query-params";

export function useSearchCompanyDocumentParam() {
  const [search, setSearch] = useQueryParam("search", StringParam);

  return { search: search ?? "", setSearch };
}
